<template>
  <div
    class="size-full bg-[url('@/assets/backgrounds/moneycombe_bg_texture.svg')]"
  >
    <div
      class="bg-funky flex size-full flex-col items-center justify-center p-4"
    >
      <IconBeepaidLogo class="mb-8 w-full max-w-md" />
      <BaseCard class="w-full max-w-md p-4">
        <BaseTabs
          v-model="formView"
          :tabs="formViewOptions"
        />
        <LogInPasswordForm v-if="formView === 'Password'" />
        <LogInRequestLinkForm v-else />
      </BaseCard>
    </div>
  </div>

  <BaseInnerLoading v-if="isLoggingInWithToken" />
</template>

<script setup lang="ts">
const { isLoggedIn } = useAuth()
const router = useRouter()
const route = useRoute()

const formViewOptions = ["Password", "Email Link"]
type FormView = (typeof formViewOptions)[number]
const formView = ref<FormView>("Password")

whenever(
  () => isLoggedIn.value,
  () => {
    router.push({ name: "home" })
  },
  { immediate: true }
)

const isLoggingInWithToken = ref(false)
onMounted(async () => {
  const token = route.query?.token

  if (!token) return

  router.replace({ query: {} })

  if (typeof token === "string") {
    isLoggingInWithToken.value = true
    try {
      await handleLogInLink(token)
    } finally {
      isLoggingInWithToken.value = false
    }
  }
})
</script>

<style lang="scss" scoped>
.bg-funky {
  background: radial-gradient(
    at 50% 50%,
    rgb(var(--color-secondary) / 0.1) 0%,
    rgb(var(--color-accent) / 0.1) 20%,
    rgb(var(--color-primary) / 0.08) 40%,
    transparent 70%,
    white 90%
  );
}
</style>
